<template>
  <transload-and-deliver :back="{ name: 'IncidentProcessTransload' }"/>
</template>

<script>
import TransloadAndDeliver from "@/components/3pl/IncidentAndRequest/Transload/TransloadAndDeliver";
export default {
  components: { 
    TransloadAndDeliver,
  },
};
</script>

<style>
</style>